'use client';

import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';

import { Button } from '@/components/ui/button';
import { Icon } from '@/components/ui/icon';

type ErrorContentProps = {
  title: string;
  description: string;
  actions?: ReactNode;
  showHomeButton?: boolean;
  onHomeClick?: () => void;
};

function ErrorContent(props: ErrorContentProps) {
  const {
    title,
    description,
    actions,
    showHomeButton = true,
    onHomeClick,
  } = props;
  const translate = useTranslations();

  const handleHomeClick = () => {
    if (onHomeClick !== undefined) {
      onHomeClick();
    } else {
      window.location.href = '/';
    }
  };

  return (
    <div className="flex min-h-dvh flex-col items-center justify-center bg-background px-4 py-12 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-md text-center">
        <Icon
          icon="material-symbols:error"
          className="flex w-full items-center justify-center text-primary"
          size={80}
        />
        <h1 className="mt-4 text-3xl font-bold tracking-tight text-foreground sm:text-4xl">
          {title}
        </h1>
        <p className="mt-4 text-muted-foreground">{description}</p>
        {(showHomeButton === true || actions !== undefined) && (
          <div className="mt-8 flex justify-center gap-4">
            {actions}
            {showHomeButton === true && (
              <Button
                onClick={handleHomeClick}
                variant="primary"
                startIcon="material-symbols:home"
              >
                {translate('goHome')}
              </Button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default ErrorContent;
